import React, { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import ViewDetails from '../leads/ViewDetails';
import ViewServiceReq from '../leads/ViewServiceReq';
import HospitalPreview from '../leads/HospitalPreview';
import CompanyPreview from '../leads/CompanyPreview';
import EditHospitalProfile from '../leads/EditHospitalProfile';
import EventPreview from '../leads/EventPreview';
import EditCompany from '../leads/EditCompany';
import EditEvent from '../leads/EditEvent';
import ServiceDetails from './ServiceDetails';



const AddProposal = lazy(() => import('../Proposals/AddProposal'));
const ViewProposal = lazy(() => import('../Proposals/ViewProposal'));

const ProposalModule = () => {
  return (
    <Suspense fallback={null}>
       <Routes>
        <Route path="addProposal" element={<AddProposal  />} />
        <Route path="convertToProposal" element={<AddProposal  />} />
        <Route path="viewProposal" element={<ViewProposal />} />
        <Route path="declineProposal" element={<ViewProposal />} />
        <Route path="ViewDetails" element={<ViewDetails />} />
        <Route path="viewProposal/viewServiceReq" element={<ViewServiceReq />} />
        <Route path="viewProposal/previewHospital" element={<HospitalPreview />} />
        <Route path="viewProposal/previewCompany" element={<CompanyPreview />} />
        <Route path="viewProposal/eventPreview" element={<EventPreview />} />
        <Route path="viewProposal/editHospitals" element={<EditHospitalProfile />} />
        <Route path="viewProposal/editCompany" element={<EditCompany />} />
        <Route path="viewProposal/editEvent" element={<EditEvent />} />
        <Route path="viewProposal/serviceDetails" element={<ServiceDetails />} />
      </Routes>
    </Suspense>
  )
}

export default ProposalModule
